import axios from 'axios';
import apibase from './baseAPI';
import lib from '../biz/lib';

const agentLogin = async (params) => {
    // lib.log(params)
    const url = `/agents/login`;
    try {
        const result = await apibase.post(url, params);
        // lib.log(result.data)
        return result.data;
    } catch (err) {
        throw err;
    }
};

const getUserSignOnKey = async (secretKey) => {
    const url = `/agents/signon/${secretKey}`;
    try {
        const result = await apibase.post(url);
        return result.data;
    } catch (err) {
        throw err;
    }
};

const peekPurchaseSerialCode = async (id) => {
    const url = `/agents/${id}/secureform/peek/serialCodeNo`;
    try {
        const result = await apibase.get(url);
        return result.data;
    } catch (err) {
        throw err;
    }
};

const peekRentSerialCode = async (id) => {
    const url = `/agents/${id}/rentform/peek/serialCodeNo`;
    try {
        const result = await apibase.get(url);
        return result.data;
    } catch (err) {
        throw err;
    }
};

const peekRentReceiptSerialCode = async (id) => {
    const url = `/agents/${id}/rentCumReceiptForm/peek/serialCodeNo`;
    try {
        const result = await apibase.get(url);
        return result.data;
    } catch (err) {
        throw err;
    }
};

const peekPurchaseCumReceiptSerialCode = async (id) => {
    const url = `/agents/${id}/purchaseCumReceiptForm/peek/serialCodeNo`;
    try {
        const result = await apibase.get(url);
        return result.data;
    } catch (err) {
        throw err;
    }
};

const peekDeveloperSaleSerialCode = async (id) => {
    const url = `/agents/${id}/developerSalesForm/peek/serialCodeNo`;
    try {
        const result = await apibase.get(url);
        return result.data;
    } catch (err) {
        throw err;
    }
};

const peekEmploymentFormSerialCode = async (id) => {
    const url = `/agents/${id}/employmentForm/peek/serialCodeNo`;
    try {
        const result = await apibase.get(url);
        return result.data;
    } catch (err) {
        throw err;
    }
};

const getBranchDetails = async (id) => {
    const url = `/agents/${id}/branch`;
    try {
        const result = await apibase.get(url);
        return result.data;
    } catch (err) {
        throw err;
    }
};

const keyValue = async (search, userStatus) => {
    const params = {
        search: search,
        userStatus: userStatus,
    };
    const url = `/agents/keyValue`;
    try {
        const result = await apibase.post(url, params)
        return result.data;
    } catch (err) {
        throw err;
    }
};

const createNextsixAgentLink = async (agentId) => {
    const params = {
        agentId: agentId
    };
    const url = `/agents/createNextsixAgentLink`;
    try {
        const result = await apibase.post(url, params)
        return result.data;
    } catch (err) {
        throw err;
    }
};

const resetPassword = async (agentId, loginName, userPassword) => {
    const params = {
        agentId: agentId,
        loginName: loginName,
        userPassword: userPassword
    };
    const url = `/agents/resetPassword`;
    try {
        const result = await apibase.post(url, params)
        return result.data;
    } catch (err) {
        throw err;
    }
};

const uploadProfileImage = async (agentId, codebase64) => {
    const params = {
        id: agentId,
        codebase64: codebase64,
        fileName: 'profile'
    };
    // console.log(params)
    const url = `/agents/uploadProfileImage`;
    try {
        const result = await apibase.post(url, params)
        return result.data;
    } catch (err) {
        throw err;
    }
}

const getAgentDetails = async (id) => {    
    const url = `/agents/${id}`;
    try {
        const result = await apibase.get(url)
        return result.data;
    } catch (err) {
        throw err;
    }
}


export default {
    getUserSignOnKey: getUserSignOnKey,
    peekPurchaseSerialCode: peekPurchaseSerialCode,
    peekRentSerialCode: peekRentSerialCode,
    peekRentReceiptSerialCode: peekRentReceiptSerialCode,
    peekPurchaseCumReceiptSerialCode: peekPurchaseCumReceiptSerialCode,
    peekDeveloperSaleSerialCode: peekDeveloperSaleSerialCode,
    peekEmploymentFormSerialCode: peekEmploymentFormSerialCode,
    getBranchDetails: getBranchDetails,
    keyValue: keyValue,
    createNextsixAgentLink: createNextsixAgentLink,
    resetPassword: resetPassword,
    agentLogin: agentLogin,
    uploadProfileImage: uploadProfileImage,
    getAgentDetails: getAgentDetails
};